"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("./app"));
var react_1 = __importDefault(require("react"));
var client_1 = require("react-dom/client");
var root = (0, client_1.createRoot)(document.getElementById("root"));
root.render(react_1.default.createElement(app_1.default, null));
